import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const AboutusBanner = () => {
  const { t } = useTranslation();
  return (
    <div>
      <section>
        <div className="aboutus-banner-warp">
          <div className="aboutus-banner">
            <div className="banner-bg">
              <div className="mask"></div>
              {/* <img src={"//files.authing.co/authing-website/banner-abuout.jpg"} alt="" /> */}
            </div>
            <div>
              <div className="title">{t("about.banner.title")}</div>
              <div className="subtitle">{t("about.banner.subtitle")}</div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="aboutus-banner-data">
          <div className="inner">
            <div className="items-warp">
              <div className="item">
                <div className="num">100 M+ </div>
                <div className="label">{t("about.banner.label-one")}</div>
              </div>
              <div className="item">
                <div className="num">30 + </div>
                <div className="label">{t("about.banner.label-two")}</div>
              </div>
              <div className="item">
                <div className="num">1 V 1</div>
                <div className="label">{t("about.banner.label-three")}</div>
              </div>
              <div className="item">
                <div className="num">24/7</div>
                <div className="label">{t("about.banner.label-four")}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
